import { Link } from "react-router-dom";
import { useLocale } from "../contexts/LocaleContext";
import "./styles/thankyou.css";

export function ThankyouPage() {
  const { t } = useLocale();

  return (
    <section
      className="wrapper thankyou-page"
      aria-label={t("paymentSuccess.ariaLabel")}
    >
      <div className="thankyou-box">
        <div className="thankyou-graphic">
          <img
            src="/static/img/Heartfelt-Thank-You.png"
            alt={t("paymentSuccess.thankYouAlt")}
          />
        </div>

        <h1>{t("paymentSuccess.thankYouTitle")}</h1>

        <p>
          {t("paymentSuccess.thankYouText")}
          <br />
          {t("paymentSuccess.thankYouProfile")}
        </p>

        <div className="thankyou-action">
          <Link to="/profile" className="btn-profile">
            {t("paymentSuccess.toProfile")}
          </Link>
        </div>
      </div>
    </section>
  );
}
